module.exports = __webpack_public_path__ + "static/img/4.0593105.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/4.png
// module id = S3MI
// module chunks = 0